export const PARTY = 'Party';
export const PartyTypeValues = ['PF', 'PJ'];
/** pt-BR labels for {@link PartyType}. */
export const PARTY_TYPE_LABELS = {
    PF: 'Pessoa Física',
    PJ: 'Pessoa Jurídica',
};
export const PartyRoleTypeValues = [
    'CUSTOMER',
    'SUPPLIER',
];
/** pt-BR labels for {@link PartyRoleType}. */
export const PARTY_ROLE_LABELS = {
    CUSTOMER: 'Cliente',
    SUPPLIER: 'Fornecedor',
};
//# sourceMappingURL=party.js.map